export default function filtersToSearchParams(filters, offset, limit) {

    let url = new URL('http://nahodka.localhost/api/');

    if (filters && Object.keys(filters).length) {
        Object.entries(filters).forEach(([key, value]) => {
            if (value) {
                url.searchParams.set(key, String(value))
            }
        })
    }

    if (offset) url.searchParams.set(`offset`, offset)
    if (limit) url.searchParams.set(`limit`, limit)

    return url.search;
}
